import { DISABLE_COMPARISONS_INTERNAL_ID } from '../constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export const useAllowComparison = () => {
  // HACK: isDisable конвертится в isAllow для упрощения, чтобы не фиксить тесты
  const isDisabled = useHideSomeExperiment(DISABLE_COMPARISONS_INTERNAL_ID);
  return !isDisabled;
};
